module.exports = "/images/telinet.svg?ff9093dc7c0bac8d794e4298ea3fc834";